/**
 * Base64 for Secret payloads.
 *
 * A Secret's `data` is base64 on the wire, so a value typed into the create
 * form has to be encoded before it is sent. btoa alone throws on anything
 * outside Latin-1, so the string is converted to UTF-8 bytes first - a
 * password with a non-ASCII character would otherwise fail at submit time.
 */
export const encodeSecretValue = (value: string): string => {
    const utf8 = unescape(encodeURIComponent(value));

    return typeof btoa === "function" ? btoa(utf8) : Buffer.from(utf8, "binary").toString("base64");
};

/**
 * The decoded byte length of a base64 payload, computed from the encoded
 * length so the value itself is never decoded or held in memory.
 */
export const decodedByteLength = (encoded: string): number => {
    const clean = (encoded || "").replace(/[^A-Za-z0-9+/=]/g, "");

    if (!clean) {
        return 0;
    }

    const padding = clean.endsWith("==") ? 2 : clean.endsWith("=") ? 1 : 0;

    return Math.max(0, (clean.length * 3) / 4 - padding);
};
